import { render, staticRenderFns } from "./SideBarDropdown.vue?vue&type=template&id=bcd9031e&scoped=true"
import script from "./SideBarDropdown.vue?vue&type=script&lang=js"
export * from "./SideBarDropdown.vue?vue&type=script&lang=js"
import style0 from "./SideBarDropdown.vue?vue&type=style&index=0&id=bcd9031e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd9031e",
  null
  
)

export default component.exports